module.exports = __webpack_public_path__ + "static/media/shopping-basket.8a30790e.svg";